export default "__VITE_ASSET__UtA9Is4y__"